import { render, staticRenderFns } from "./VideoStatsCard.vue?vue&type=template&id=1c70a753&scoped=true&"
import script from "./VideoStatsCard.vue?vue&type=script&lang=js&"
export * from "./VideoStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoStatsCard.vue?vue&type=style&index=0&id=1c70a753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70a753",
  null
  
)

export default component.exports